/**
 * Deploy / test server. Lokalno: otkomentariši localhost, zakomentariši test-back.
 */
export const ADMIN_API_BASE = "https://test-back.firebird.rs";
// export const ADMIN_API_BASE = "http://localhost:6003";
